import { Component, OnInit, ViewChild, inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LicenseService, RnLicenseFullVM } from 'src/app/shared/services/rnapi2-service';
import { RnLicenseUpdateDTO } from '../../../services/rnapi2-service/models/models';
import { Subscription } from 'rxjs';
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { LicenseEditModalService } from './license-edit-modal.service';

@Component({
  selector: 'app-license-edit',
  templateUrl: './license-edit.component.html',
  styleUrls: ['./license-edit.component.scss'],
  standalone: false
})
export class LicenseEditComponent implements OnInit, OnDestroy {
  @ViewChild('modalRef') modalComponent: ModalComponent;
  public frmGroup!: FormGroup;
  public submitted = false;
  public normalButtonText = 'Add Organization';
  private subscriptions: Subscription[] = [];
  public licenseInfo: RnLicenseFullVM = new RnLicenseFullVM();
  private readonly licenseService: LicenseService = inject(LicenseService);
  private readonly formBuilder: FormBuilder = inject(FormBuilder);
  public readonly licenseEditModalService: LicenseEditModalService = inject(LicenseEditModalService);  

  ngOnInit(): void {
    this.frmGroup = this.formBuilder.group({
      licenseType: ['', Validators.required.bind(Validators)],
      license1: ['', Validators.required.bind(Validators)],
      license2: ['', Validators.required.bind(Validators)]
    });

    const sub = this.licenseEditModalService.modalState$.subscribe((data) => {
      if (!data) return;
      if (data?.config) {
        this.licenseInfo = data?.config;
         if (this.licenseInfo) {
          this.initializeLicenseInfo();
        }
      }
      if (data?.isOpen) {
        this.open();
      } else {
        this.close();
      }
    });
    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    for (const s of this.subscriptions) {
      s.unsubscribe();
    }
  }

  initializeLicenseInfo() {
    if (this.licenseInfo.DisplayName) {
      this.licenseType.setValue(this.licenseInfo.DisplayName);
    }
    if (this.licenseInfo.License1) {
      this.license1.setValue(this.licenseInfo.License1);
    }
    if (this.licenseInfo.License2) {
      this.license2.setValue(this.licenseInfo.License2);
    }
  }

  public open(): void {
    this.modalComponent?.open();
  }

  public close(): void {
    this.modalComponent?.close();
  }

  get licenseType() {
    return this.frmGroup.get('licenseType');
  }

  get license1() {
    return this.frmGroup.get('license1');
  }

  get license2() {
    return this.frmGroup.get('license2');
  }

  saveChanges() {
    const changes: any[] = [];
    const newLicense1 = this.frmGroup.controls['license1'].value.replace(/\D/g, '');
    const newLicense2 = this.frmGroup.controls['license2'].value.replace(/\D/g, '');
    if (newLicense1 != this.licenseInfo.License1) {
      changes.push({ Key: 'License1', Value: newLicense1 });
    }
    if (newLicense2 != this.licenseInfo.License2) {
      changes.push({ Key: 'License2', Value: newLicense2 });
    }
    if (changes.length <= 0) {
      return;
    }
    this.licenseInfo.License1 = newLicense1;
    this.licenseInfo.License2 = newLicense2;

    const payload: RnLicenseUpdateDTO = {
      AffectedOrganizationId: this.licenseInfo.OrganizationID,
      LicensesID: Number(this.licenseInfo.LicenseID),
      ItemsToUpdate: changes
    };

    this.licenseService.apiV2LicensesUpdatePost(payload).subscribe();
    this.close();
  }
}
